/**
 * Template Activity Bubble Component
 *
 * Displays activity indicators during template build.
 */

import React from 'react';
import type { ActivityMessage } from '@features/ai-chat-core';
import { AutoAwesome as AIIcon } from '@mui/icons-material';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

interface TemplateActivityBubbleProps {
  /** Activity message to display */
  activity: ActivityMessage;
}

/**
 * Template Activity Bubble - Shows AI activity status
 */
export const TemplateActivityBubble: React.FC<TemplateActivityBubbleProps> = ({
  activity,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        px: 2,
        py: 1.5,
        bgcolor: theme.palette.primary.main + '08',
        borderRadius: 2,
        border: `1px solid ${theme.palette.primary.main}20`,
      }}
    >
      <Box
        sx={{
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CircularProgress
          size={24}
          thickness={3}
          sx={{ color: theme.palette.primary.main }}
        />
        <AIIcon
          sx={{
            position: 'absolute',
            fontSize: 12,
            color: theme.palette.primary.main,
          }}
        />
      </Box>

      <Typography
        variant="body2"
        sx={{
          color: theme.palette.text.secondary,
          fontStyle: 'italic',
        }}
      >
        {activity.message}
      </Typography>
    </Box>
  );
};

